export default "__VITE_ASSET__f1d91ddd__"